import {
  getWorkerStripeStatusResponseSchema,
  type WorkerStripeStatusResponse,
} from "@clipboard-health/contract-payment-service";
import { get } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib/analytics";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";
import { useQuery, type UseQueryResult } from "@tanstack/react-query";

const STALE_TIME_24_HOURS_IN_MS = 24 * 60 * 60 * 1000;

interface UseGetWorkerStripeStatusOptions {
  enabled?: boolean;
}

export function getWorkerStripeStatusQueryKey(workerId: string) {
  return ["worker-stripe-status", workerId];
}

function getWorkerStripeStatusUrl(workerId: string) {
  return `${environmentConfig.REACT_APP_PAYMENTS_API_URL}/accounts/${workerId}/stripe-status`;
}

export function useGetWorkerStripeStatus(
  options?: UseGetWorkerStripeStatusOptions
): UseQueryResult<WorkerStripeStatusResponse> {
  const worker = useDefinedWorker();
  const workerId = worker.userId;
  return useQuery({
    queryKey: getWorkerStripeStatusQueryKey(workerId),
    queryFn: async () => {
      const response = await get({
        url: getWorkerStripeStatusUrl(workerId),
        responseSchema: getWorkerStripeStatusResponseSchema,
      });
      return response.data;
    },
    ...options,
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.STRIPE_RESTRICTION_BANNER_GET_STATUS_FAILURE,
    },
    staleTime: STALE_TIME_24_HOURS_IN_MS,
    cacheTime: STALE_TIME_24_HOURS_IN_MS,
  });
}
